import React, { useEffect, useState } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { useNavigate } from "react-router-dom";
import { getAppContent } from "../../api/apiHandler";
import { showErrorMessage } from "../common/Utils";
import HtmlContent from "../../components/htmlcontent/HtmlContent";

export function Privacycms() {

    let navigate = useNavigate();
    const auth = localStorage.getItem('token');
    
    // Redirect to login if not logged in
    if (!auth) {
        navigate('/login');
    }

    const [appContent, setAppContent] = useState({
        content_title: '',
        content_key: '',
        content_value: ''
    });
    
    useEffect(() => {
        async function getAppData() {
            const contentReq = {
                type: 'policy_content'
            }
            const response = await getAppContent(contentReq);
            if (parseInt(response.code) === 1) {
                setAppContent(response.data);
            } else {
                showErrorMessage(response.message);
            }
        }
        getAppData();
    }, []);
    
    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Privacy Policy</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" />
                                    Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Privacy Policy</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="header">
                                    <div className="col-12 text-left">
                                        <a 
                                            href="#"
                                            onClick={handleGoBack} 
                                            className="btn btn-raised bg-primary waves-effect waves-red text-left"
                                        >
                                                <i className="zmdi zmdi-arrow-left"></i>
                                        </a>
                                        <a 
                                            style={{ float:'right' }} 
                                            href="/authpanel/app-content/update-privacy-policy" 
                                            className="btn btn-raised bg-primary waves-effect waves-red text-left"
                                        >
                                            <i className="zmdi zmdi-edit"></i>
                                        </a>
                                    </div>
                                </div>
                                <div className="body">
                                    <center><h4 className=""><b>Privacy Policy content</b></h4></center>
                                    <hr />
                                    <div className="col-md-12 col-lg-12 col-xl-12">
                                        <HtmlContent html={appContent.content_value} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}